"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tabs = exports.Tab = exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

require("../css/tab.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Tab = function Tab(_ref) {
  var active = _ref.active,
      title = _ref.title,
      theme = _ref.theme,
      disabled = _ref.disabled,
      other = _objectWithoutProperties(_ref, ["active", "title", "theme", "disabled"]);

  var classes = (0, _classnames.default)({
    'vn-tabs__tab': true,
    'vn-tabs__tab--active': active,
    'vn-tabs__tab--enabled': !active && !disabled,
    'vn-tabs__tab--disabled': disabled
  });
  return _react.default.createElement("a", _extends({}, other, {
    className: classes,
    role: "tab",
    tabIndex: 0
  }), title);
};

exports.Tab = Tab;
Tab.displayName = 'Tab';
Tab.propTypes = {
  active: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  onKeyPress: _propTypes.default.func,
  theme: _propTypes.default.string,
  title: _propTypes.default.string.isRequired
};
Tab.defaultProps = {
  active: false,
  disabled: false,
  onClick: function onClick() {},
  onKeyPress: function onKeyPress() {},
  theme: 'tab'
};

var Tabs =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Tabs, _React$Component);

  function Tabs(props) {
    var _this;

    _classCallCheck(this, Tabs);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tabs).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleTabClick", function (index, event) {
      event.preventDefault();

      if (_this.isTabDisabled(index)) {
        return;
      }

      _this.setState({
        activeTabIndex: index
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleTabKeyPress", function (index, event) {
      if (event.which === 13) {
        event.preventDefault();

        if (_this.isTabDisabled(index)) {
          return;
        }

        _this.setState({
          activeTabIndex: index
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isTabDisabled", function (index) {
      return _this.props.children[index].props.disabled;
    });

    var activeTabIndex = props.activeTabIndex;
    var isTabDisabled = _this.props.children[activeTabIndex].props.disabled;

    if (isTabDisabled) {
      activeTabIndex = -1;
    }

    _this.state = {
      activeTabIndex: activeTabIndex
    };
    return _this;
  }

  _createClass(Tabs, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var activeTabIndex = nextProps.activeTabIndex;

      if (this.state.activeTabIndex !== activeTabIndex && !this.isTabDisabled(activeTabIndex)) {
        this.setState({
          activeTabIndex: activeTabIndex
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          mountAllTabContents = _this$props.mountAllTabContents,
          theme = _this$props.theme;
      var activeTabIndex = this.state.activeTabIndex;
      var className = (0, _classnames.default)((_classNames = {
        'vn-tabs': true
      }, _defineProperty(_classNames, "vn-tabs--".concat(theme, "-theme"), true), _defineProperty(_classNames, this.props.className, this.props.className), _classNames));
      return _react.default.createElement("div", {
        className: className,
        role: "tablist"
      }, _react.default.createElement("nav", null, _react.Children.map(children, function (tab, index) {
        var active = index === activeTabIndex;

        var onClick = function onClick(e) {
          tab.props.onClick(e);

          _this2.handleTabClick(index, e);
        };

        var onKeyPress = function onKeyPress(e) {
          tab.props.onKeyPress(e);

          _this2.handleTabKeyPress(index, e);
        };

        return (0, _react.cloneElement)(tab, {
          active: active,
          onClick: onClick,
          onKeyPress: onKeyPress,
          theme: theme
        });
      })), _react.Children.map(children, function (tab, index) {
        var active = index === activeTabIndex;
        var contentClassName = (0, _classnames.default)({
          'vn-tabs__content': true,
          'vn-tabs__content--hidden': !active
        });
        return (active || mountAllTabContents) && _react.default.createElement("div", {
          className: contentClassName,
          role: "tabpanel",
          hidden: !active
        }, tab.props.children);
      }));
    }
  }]);

  return Tabs;
}(_react.default.Component);

exports.Tabs = Tabs;
Tabs.displayName = 'Tabs';
Tabs.propTypes = {
  activeTabIndex: _propTypes.default.number.isRequired,
  children: _propTypes.default.arrayOf(_propTypes.default.element).isRequired,
  className: _propTypes.default.string,
  mountAllTabContents: _propTypes.default.bool,
  theme: _propTypes.default.oneOf(['tab', 'underline'])
};
Tabs.defaultProps = {
  className: null,
  mountAllTabContents: false,
  theme: 'tab'
};
var _default = Tab;
exports.default = _default;